"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HopGateway = exports.hopSDKOptions = void 0;
const tslib_1 = require("tslib");
const sdk_1 = require("@hop.ag/sdk");
const bn_js_1 = tslib_1.__importDefault(require("bn.js"));
const alphafi_sdk_1 = require("@alphafi/alphafi-sdk");
exports.hopSDKOptions = {
    api_key: (0, alphafi_sdk_1.getConf)().HOP_API_KEY,
    fee_bps: (0, alphafi_sdk_1.getConf)().HOP_FEE_BPS,
    fee_wallet: (0, alphafi_sdk_1.getConf)().HOP_QUERY_WALLET,
};
class HopGateway {
    constructor(sdkOptions) {
        const rpc_url = (0, alphafi_sdk_1.getSuiNodeUrl)();
        this.hopAPI = new sdk_1.HopApi(rpc_url, sdkOptions);
    }
    async getQuote(options, debug = false) {
        const { pair, inAmount, outAmount } = options;
        let amount = new bn_js_1.default(0);
        if (inAmount) {
            amount = inAmount;
        }
        else if (outAmount) {
            amount = outAmount;
        }
        const params = {
            token_in: pair.coinA.type,
            token_out: pair.coinB.type,
            amount_in: BigInt(amount.toString()),
        };
        if (debug) {
            console.debug("fetchQuote Params:");
            console.debug(params);
        }
        const quote = await this.hopAPI.fetchQuote(params);
        return quote;
    }
    async getTransactionBlock(options, quote, debug = false, transaction = undefined) {
        const { senderAddress, slippage } = options;
        const splippageBPS = slippage * 100;
        let params;
        if (transaction) {
            params = {
                trade: quote.trade,
                sui_address: senderAddress,
                max_slippage_bps: splippageBPS,
                base_transaction: transaction,
            };
        }
        else {
            params = {
                trade: quote.trade,
                sui_address: senderAddress,
                max_slippage_bps: splippageBPS,
            };
        }
        if (debug) {
            console.debug("fetchTx Params:");
            console.debug(params);
        }
        const trade = await this.hopAPI.fetchTx(params);
        return trade.transaction;
    }
}
exports.HopGateway = HopGateway;
//# sourceMappingURL=hop.js.map